module.exports = __webpack_public_path__ + "rosacea_8_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/rosacea_8_after.jpg
// module id = 991
// module chunks = 0